var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m8 17.5-.7 3.6M29.6 17.4h2.7M10.9 17.4H8.2M6.8 21.8V30h1.6v-2.4h24.2V30h1.1v-8.2M32.6 17.1v-6M7.9 11.1v6M29.3 17.9c0 .3-.2.6-.6.7q-3.75.45-7.5 0c-.4 0-.6-.4-.6-.7.1-1.4.3-2.7.4-4.1 0-.3.3-.7.6-.8q3.3-1.05 6.6 0c.3.1.6.5.6.8.2 1.3.4 2.7.5 4.1M19.9 17.9c0 .3-.2.6-.6.7q-3.75.45-7.5 0c-.4 0-.6-.4-.6-.7.1-1.4.3-2.7.4-4.1 0-.3.3-.7.6-.8q3.3-1.05 6.6 0c.3.1.6.5.6.8.2 1.3.3 2.7.5 4.1M32.5 17.5l.7 3.6M6.8 21.8h26.9M6.5 10.5h27.2"
}))));
export default SvgBed;